module.exports = __webpack_public_path__ + "static/media/comment-music.e6affedd.svg";